import { useOutletContext } from 'react-router-dom';
import PaymentsTable from '../../components/PaymentsTable';
import DefaultLayoutV3 from '../../layout/DefaultLayoutV3';
import { WorkspaceOutletContext } from '../../types/workspaceTypes';

const Payments = () => {
  const { workspaceId } = useOutletContext<WorkspaceOutletContext>();

  return (
    <DefaultLayoutV3.Content>
      <h2>Statements</h2>
      <PaymentsTable isWorkspaceSettingsPage workspaceId={workspaceId} />
    </DefaultLayoutV3.Content>
  );
};

export default Payments;
